/* The editor's unsaved work, kept while the person is elsewhere in the app: leaving the
   Skills page from the sidebar, a tab or a link never loses it, and coming back opens
   the editor where they left it. Held for the page's life only — a reload or a closed
   tab asks first instead (`beforeunload` in the editor). Back inside Skills asks too;
   saving or discarding drops it.

   A module variable rather than state, because the page that holds the editor unmounts
   when the person leaves it. It is keyed by the account (the person in one workspace),
   so another sign-in or workspace in the same tab never opens someone else's work. */

import { useSettings } from "@/shared/api/settings";

import type { DraftFile, SkillMd } from "./folder";

export interface KeptDraft {
  /** Whose work it is: `useAccount()` when it was kept. */
  account: string;
  /** The skill being edited; null for a new one. */
  skillId: string | null;
  /** The version the work started from, which its save names: kept across someone else's
      newer version, it is refused as changed since, never saved over it. */
  version: string | null;
  md: SkillMd;
  files: DraftFile[];
  open: string;
}

let kept: KeptDraft | null = null;

/** The person in this workspace, once settings are read; null before. */
export function useAccount(): string | null {
  const { data } = useSettings();
  return data?.org ? `${data.user.id}:${data.org.id}` : null;
}

export const keptDraft = (account: string | null): KeptDraft | null => (account && kept?.account === account ? kept : null);

export function keepDraft(draft: KeptDraft) {
  kept = draft;
}

export function dropDraft() {
  kept = null;
}
